module.exports = __webpack_public_path__ + "static/media/egg_boil.02a31376.png";